import React, { useState } from 'react';
import { makeStyles } from '../library';
import { Button, ViewEntity } from '..';
import { ExperimentIcon } from '../icons';
import { changeLogs } from '../../enums';

const Experiment = props => {
    const { children } = props;
    const [exec, setExec] = useState(false);

    return (
        <>
            <Button
                hidden={false}
                toolTipText={'Experimentos Varios'}
                disabled={false}
                onClick={event => {
                    setExec(!exec);
                }}
                icon={<ExperimentIcon />}
                float={true}
            />
            {React.cloneElement(children)}
        </>
    );
};

export default Experiment;
